import React, { useContext, useEffect, useState } from 'react';
import { BsAward, BsCheck, BsExclamation, BsFolderPlus } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import Alert from '../../../components/Alert';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { H5 } from '../../../components/Typography/styles';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import {
  DocumentSigningContent,
  DocumentSigningIcon
} from './styles';
import { attemptsOtp, documentSigningSteps } from '../../../helpers/enum';
import { diffBetweenDateInSeconds } from '../../../helpers/date';
import { getOtpCodeFromDocuments, acceptCodeFromDocuments } from '../../../services/otp';
import { DocumentSigningContext } from '../../../store';
import Otp from '../../../components/Otp';
import ModalAction from '../../../components/ModalAction';
import ModalInfo from '../../../components/ModalInfo';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import Loader from '../../../components/Loader';
import { useForm, Controller } from 'react-hook-form';
import { getAdoCode, validateAdoCode } from '../../../services/ado';
import InputDefault from '../../../components/InputDefault';
import RadioButtonForm from '../../../components/RadioButtonForm';

const DigitalDocumentsPage = ({ setActiveStep, setLastStep }) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const { register, control, errors, handleSubmit, trigger, setValue } = useForm();
  const ids=['ssn-1', 'ssn-2', 'ssn-3', 'ssn-4', 'ssn-5', 'ssn-6'];
  const { documentSigning, setDocumentSigning } = useContext(DocumentSigningContext);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [time, setTime] = useState(0);
  const [timeWidth, setTimeWidth] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [errorOtp, setErrorOtp] = useState(false);
  const [disableOtpFields, setDisableOtpFields] = useState(false);
  const [showSuccessOtpModal, setShowSuccessOtpModal] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalInfoErrorDocuments, setShowModalInfoErrorDocuments] = useState(false);
  const [showModalInfoADO, setShowModalInfoADO] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ssnValues, setSsnValues] = useState({
    ssn1: "",
    ssn2: "",
    ssn3: "",
    ssn4: "",
    ssn5: "",
    ssn6: ""
  });
  const [showAdoCode, setShowAdoCode] = useState(false);
  const [origenCodigo, setOrigenCodigo] = useState({ label: 'ADO', value: 'ADO' });

  async function acceptOtpVerification() {
    try {
      setShowModalInfoADO(false);
      setIsLoading(true);

      const data = {
        idCredito: documentSigning.credit.id,
        idCliente: documentSigning.credit.idCliente,
        idUsuario: session.idAsesor
      }

      const response = await getOtpCodeFromDocuments(data);
      console.log(response.data)
      setShowOtpModal(true);
      const seconds = diffBetweenDateInSeconds(response.data.fechaVencimiento);
      setTime(seconds.toFixed(0));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  async function resendCode() {
    try {

        setIsLoading(true);

        const data = {
          idCredito: documentSigning.credit.id,
          idCliente: documentSigning.credit.idCliente,
          idUsuario: session.idAsesor
        }

        const response = await getOtpCodeFromDocuments(data);
        // console to get the code (msg/email doesn't working yet)
        console.log(response.data);

        setShowOtpModal(true);
        const seconds = diffBetweenDateInSeconds(response.data.fechaVencimiento);
        setTime(seconds.toFixed(0));
        setIsLoading(false);
      
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function clearFields() {
    var ary= ids.reverse();
    ary.forEach(function(item,index) {
       var ssn = document.querySelector(
         `input[name=${item}]`
       );
       ssn.value = '';
       ssn.focus();
     })
   }

  function handleChangeOtp(e) {
    const { maxLength, value, name } = e.target;
    const [fieldName, fieldIndex] = name.split("-");

    if (value.length >= maxLength) {
      if (parseInt(fieldIndex, 10) < 6) {
        const nextSibling = document.querySelector(
          `input[name=ssn-${parseInt(fieldIndex, 10) + 1}]`
        );

        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }

    setSsnValues({
      ...ssnValues,
      [`ssn${fieldIndex}`]: value
    });
  }

  async function changeModalSteps() {
    setShowSuccessOtpModal(false);
    setLastStep(documentSigningSteps.DOWNLOAD_DOCUMENTS);
    setActiveStep(documentSigningSteps.UPLOAD_DOCUMENTS);
  }

  async function sendOtpCode(code) {
    try {
      setShowOtpModal(false);
      setIsLoading(true);
      setDisableOtpFields(true);

      const data = {
        idCredito: documentSigning.credit.id,
        idCliente: documentSigning.credit.idCliente,
        token: code
      }

      await acceptCodeFromDocuments(data);
      setIsLoading(false);
      setShowSuccessOtpModal(true);
    } catch (error) {
      console.log(error)
      console.log(error.response)
      setShowModalInfoErrorDocuments(true);
      setIsLoading(false);
    }
  }

  async function initializeStateComponent() {
    const code = "";
    sendOtpCode(code)
  }

  useEffect(() => {
    setErrorOtp(false)

    if(ssnValues.ssn1 !== "" &&
    ssnValues.ssn2 !== "" &&
    ssnValues.ssn3 !== "" &&
    ssnValues.ssn4 !== "" &&
    ssnValues.ssn5 !== "" &&
    ssnValues.ssn6 !== "" && 
    !showSuccessOtpModal) {
    const { ssn1, ssn2, ssn3, ssn4, ssn5, ssn6 } = ssnValues;
    const code = ssn1+ssn2+ssn3+ssn4+ssn5+ssn6;
    sendOtpCode(code)
  }
  }, [ssnValues]);

  useEffect(() => {
    initializeStateComponent();
  }, [])

  return (
    <FormTemplate 
      idForm="digital-docments-step-page"
      activeStep="1/3"
      stepLabel="Firma digital documentos">
      <Alert
        style={{marginTop: 20}} 
        custom
        backgroundAlert={colors.textExGrayLight}
        borderAlert={colors.grayLight}
        backgroundIcon={colors.textHyperlink}
        icon={<BsFolderPlus size={18} color={colors.white} />}
        description="Continuamos con la parte final del proceso, donde se generan unos documentos y según requerimiento de la pagaduría algunos se firman físicamente."
      />
      <DocumentSigningContent>
        <DocumentSigningIcon>
          <BsAward color={colors.textPrimary} size={32} />
        </DocumentSigningIcon>
        <H5 color={colors.textPrimary}> Generación parcial de documentos.</H5>
      </DocumentSigningContent>
      <br></br>
      
      {isLoading && <Loader />}

      <Otp
        open={showOtpModal}
        setShowOtpModal={setShowOtpModal}
        handleChangeOtp={handleChangeOtp}
        fields={ids}
        timer={time}
        timeWidth={timeWidth}
        errorOtp={errorOtp}
        disalbedFields={disableOtpFields}
        resendCode={resendCode}
        attempts={attempts}
        totalAttempts={attemptsOtp.max}
      />

      <ModalAction
        open={showSuccessOtpModal}
        setShowModal={setShowSuccessOtpModal}
        actionFunctionUpButton={() => changeModalSteps()}
        title="La generación de documentos para tu solicitud fue realizada exitosamente"
        actionLabelFunctionUpButton="Confirmar"
        description="Se ha enviado una copia al Cliente de todos los documentos firmados digitalmente al correo electrónico registrado."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />

      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title="Has excedido el número de intentos"
        description="Espera 24 horas para intentar de nuevo desde la opción del menu Mis solicitudes, o comunicate con el líder para habilitar de nuevo el proceso de prospección del cliente."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalInfo
        open={showModalInfoErrorDocuments}
        setShowModal={setShowModalInfoErrorDocuments}
        title="Error en generación de documentos"
        description="Contacte al administrador del sistema. Intenta de nuevo desde la opción del menu Mis solicitudes"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalActionCongratulations
        open={showModalInfoADO}
        setShowModal={setShowModalInfoADO}
        actionFunctionUpButton={() => acceptOtpVerification()}
        title="Código de validación de identidad verificado de manera exitosa."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
    </FormTemplate>
  )
}

export default DigitalDocumentsPage;
